import type { ReactElement } from 'react'
import { RadioGroup } from 'app/components/ui/radio-group'
import type { ListVisibility } from 'app/types/list-visibility'

const OPTIONS: { value: ListVisibility; label: string }[] = [
  { value: `shared`, label: `Shared` },
  { value: `personal`, label: `Only me` },
]

/** Shared or Only me, offered where a list is made and, to its creator, where it is edited. */
export function ListVisibilityField({
  value,
  onChange,
  label,
  disabled,
}: {
  value: ListVisibility
  onChange: (visibility: ListVisibility) => void
  /** Leave undefined where the surrounding row already names the choice. */
  label?: string
  disabled?: boolean
}): ReactElement {
  return (
    <RadioGroup
      label={label}
      values={OPTIONS}
      value={value}
      disabled={disabled}
      orientation="horizontal"
      onChange={(next) => onChange(next as ListVisibility)}
    />
  )
}
